import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
export const CircularProgressWithLabel = ({ value, total, ...props }) => {
    const percentage = Math.round((value / total) * 100); // Calculate the percentage
    // Change color based on percentage
    const getProgressColor = () => {
        if (percentage < 40)
            return 'error'; // Red
        if (percentage < 70)
            return 'primary'; // Yellow
        return 'primary'; // Green
    };
    return (_jsxs(Box, { sx: { position: 'relative', display: 'inline-flex' }, children: [_jsx(CircularProgress, { variant: "determinate", value: percentage, color: getProgressColor(), ...props, size: 40 }), _jsx(Box, { sx: {
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }, children: _jsxs(Typography, { variant: "caption", color: 'text.primary', children: [value, "/", total] }) })] }));
};
